module.exports = __webpack_public_path__ + "img/12.c6bb43b3.png";